import { WORKDAY_HIRE_API } from './api';

/**
 * Turns a lookup field into a search box that asks the server per keystroke.
 *
 * Deliberately returns nothing for an empty query, which is what stops the
 * field fetching on mount: the applicant collection is ~4,200 rows and ~44MB,
 * and pulling it to identify one person is what timed out.
 *
 * Workday's applicant API accepts an id or an email and has no name filter of
 * any kind, so a typed name legitimately returns nothing. That is an answer,
 * not a failure — and several people can share an email, so several matches is
 * equally normal.
 */
export const makeApplicantLoader =
  (link: string) =>
  async (inputValue?: string): Promise<{ id: string; label: string }[]> => {
    const query = (inputValue || '').trim();
    if (!query) return [];

    const response = await WORKDAY_HIRE_API.applicantLookup(link, query);
    return (response?.data?.results || []).map((applicant) => ({
      id: applicant.id,
      // Both, because the id is what a recruiter searched by and the name is
      // how they confirm it is the right person.
      label: applicant.name
        ? `${applicant.id} — ${applicant.name}`
        : applicant.id,
    }));
  };
